import { call, put, takeLatest } from "redux-saga/effects";

import { ordersApi } from "@src/service/orders";
import { setGlobalLoader, setSnackbar } from "../generals/actionCreators";
import { LoadingStatus } from "../generals/types";
import {
  fetchOrdersExcelInterface,
  fetchOrdersExcelSuccess,
} from "./actionCreators";
import { OrdersExcelActionTypes } from "./types/actionTypes";

export function* fetchOrdersExcelRequest(
  action: fetchOrdersExcelInterface
): any {
  try {
    yield put(setGlobalLoader(LoadingStatus.LOADING));
    let restaurant_id = localStorage.getItem("currLocation");
    let { params } = action.payload;
    const searchParams = new URLSearchParams(params);
    const aggregators = searchParams.getAll("delivery");
    const statuses = searchParams.getAll("status");
    const startDate = searchParams.get("start_date");
    const endDate = searchParams.get("end_date");

    const { data } = yield call(ordersApi.getOrdersExcel, {
      restaurantID: restaurant_id || "",
      startDate: startDate || "",
      endDate: endDate || "",
      aggregators: aggregators,
      statuses: statuses,
    });
    yield put(fetchOrdersExcelSuccess({ code: data }));
    yield put(setGlobalLoader(LoadingStatus.SUCCESS));
  } catch (e) {
    yield put(
      setSnackbar({
        visible: true,
        status: "error",
        message: "Error fetching orders in Excel format",
      })
    );
    yield put(setGlobalLoader(LoadingStatus.ERROR));
  }
}

export function* ordersExcelSaga() {
  yield takeLatest(
    OrdersExcelActionTypes.FETCH_ORDERS_EXCEL_SAGA,
    fetchOrdersExcelRequest
  );
}
